

















import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import tinymce from 'vue-tinymce-editor/src/components/TinymceVue.vue'
import '@/sass/editor.css'
import '@/sass/editor-rtl.css'
import '@/sass/dashicons.css'
import {Medium} from '@/models/Medium'
import MediaSelector from '@/components/admin/MediaSelector.vue'
import Editor from '@/components/admin/Editor.vue'
import Post from '@/models/Post'

type tinyMce = {
  editor: {
    insertContent(content: string): void
    dom: {
      addStyle(style: string): void
    }
  }
}

@Component({
  components: {
    tinymce,
    MediaSelector,
    Editor
  }
})
export default class TinyMce extends VueBase {
  @Prop(String) readonly id!: string
  @Prop(String) readonly value!: string
  @Prop(Object) readonly post: Post
  @Prop({ type: Boolean, default: true }) readonly menubar!: boolean
  @Prop({ type: String, default: 'fontselect | fontsizeselect | formatselect | bold | italic | underline | strikethrough | forecolor | backcolor | removeformat | link | unlink' }) readonly toolbar1
  @Prop({ type: String, default: 'bullist | numlist | hr | media | pastetext | searchreplace | nonbreaking | alignleft | aligncenter | alignright | undo | redo' }) readonly toolbar2
  @Prop({ type: Array, default: () => [
      'advlist autolink lists link image charmap print preview hr anchor pagebreak',
      'searchreplace wordcount visualblocks visualchars code fullscreen',
      'insertdatetime media nonbreaking save table contextmenu directionality',
      'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr'
    ]}) readonly plugins
  @Emit()
  input(value: string): string {
    return value
  }

  get internalValue(): string {
    return this.value
  }

  set internalValue(val: string) {
    this.input(val)
  }

  options = {
    language_url: require('./ja.js'),
    content_styles: ['img { max-width: 100%; }']

  }
  showedMediaSelector = false

  mounted(): void {
    this.$nextTick(() => {
      setTimeout(() => {
        (this.$refs.tm as unknown as tinyMce)?.editor?.dom?.addStyle('img { height: auto; max-width: 100%; }')
      }, 1000)
    })
  }

  onSelectMedia(media: Array<Medium>): void {
    media.forEach(m => {
      (this.$refs.tm as unknown as tinyMce)?.editor?.insertContent(`<img src="${m.url}" width="${m.width}" height="${m.height}" style="max-width: 100%"/>`)
    })
    this.showedMediaSelector = false
  }
}
